// extracted by mini-css-extract-plugin
export var criteriaShadow = "our-grant-process-module--criteria-shadow--2Ha-_";